import { Button } from '@customerio/pluma-components/react';
import googleLogo from '@/assets/images/login-google-logo.svg';
import * as styles from './google-auth-button.css';

type GoogleAuthButtonProps = {
  type?: 'login' | 'signup';
  /** Light (default) matches the login page; dark matches the re-auth modal (Ember's `@theme='dark'`). */
  theme?: 'light' | 'dark';
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
  'data-testid'?: string;
};

const LOGIN_STYLE = { light: styles.googleAuthButton, dark: styles.googleAuthButtonDark } as const;

/** "Sign in with Google" button. Copy + mark follow Google's branding guidelines. */
export function GoogleAuthButton({
  type = 'login',
  theme = 'light',
  isDisabled,
  isLoading,
  onClick,
  'data-testid': dataTestId,
}: GoogleAuthButtonProps) {
  const label = type === 'login' ? 'Sign in with Google' : 'Continue with Google';

  return (
    <Button
      // Explicit button type so clicking it (to open the Google popup) never
      // implicitly submits a surrounding <Form>.
      type="button"
      variant="secondary"
      // Google brand styling (white/dark surface for login, full-width for
      // signup) — see the `google*Button` styles.
      className={type === 'login' ? LOGIN_STYLE[theme] : styles.googleSignupButton}
      iconSrc={googleLogo}
      isDisabled={isDisabled}
      isLoading={isLoading}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {label}
    </Button>
  );
}
